import { Link } from "react-router-dom";
import { Wind } from "lucide-react";

// Shared site footer used on the homepage and other marketing pages.
export default function SiteFooter() {
  return (
    <footer id="contact" className="border-t border-slate-200 bg-white">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-center">
          <div>
            <div className="flex items-center gap-2">
              <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-indigo-500">
                <Wind className="h-4 w-4 text-white" strokeWidth={2.5} />
              </div>
              <span className="font-heading text-lg font-black text-slate-900">Fast Estimate</span>
            </div>
            <p className="mt-2 text-sm text-slate-500">Part of the Fast Estimate LLC family of contractor tools.</p>
          </div>
          <div className="flex flex-wrap gap-x-6 gap-y-3 text-sm font-semibold text-slate-600">
            <Link to="/compare" data-testid="footer-compare" className="hover:text-indigo-600">Compare</Link>
            <Link to="/guides" data-testid="footer-guides" className="hover:text-indigo-600">Guides</Link>
            <Link to="/blog" data-testid="footer-blog" className="hover:text-indigo-600">Blog</Link>
            <Link to="/service-areas" data-testid="footer-service-areas" className="hover:text-indigo-600">Service Areas</Link>
            <Link to="/privacy-policy" data-testid="footer-privacy" className="hover:text-indigo-600">Privacy</Link>
            <Link to="/security" data-testid="footer-security" className="hover:text-indigo-600">Security</Link>
            <Link to="/terms-of-service" data-testid="footer-terms" className="hover:text-indigo-600">Terms</Link>
            <Link to="/contact" data-testid="footer-contact" className="hover:text-indigo-600">Contact</Link>
          </div>
        </div>
        
        <p className="mt-4 text-sm text-slate-400">© 2026 Fast Estimate. All rights reserved.</p>
      </div>
    </footer>
  );
}
